import { MapPin } from 'lucide-react';

interface PropertySelectionStepProps {
  onSelect: (property: string) => void;
}

const properties = [
  { id: 'sons-rio-cibolo', name: "Son's Rio Cibolo", location: 'Marion, TX', isCurrentLocation: true },
  { id: 'sons-island', name: "Son's Island", location: 'Seguin, TX' },
  { id: 'sons-river-ranch', name: "Son's River Ranch", location: 'San Marcos, TX' },
  { id: 'sons-blue-river-camp', name: "Son's Blue River Camp", location: 'Wimberley, TX' },
  { id: 'sons-geronimo', name: "Son's Geronimo", location: 'Seguin, TX' },
  { id: 'sons-guadalupe', name: "Son's Guadalupe", location: 'New Braunfels, TX' },
];

const PropertySelectionStep = ({ onSelect }: PropertySelectionStepProps) => {
  return (
    <div className="p-8">
      <div className="text-center mb-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown mb-2">
          Choose Your Property
        </h2>
        <p className="text-brown/70">
          Which Son's property would you like to visit?
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {properties.map((property) => (
          <button
            key={property.id}
            onClick={() => onSelect(property.id)}
            className="relative flex items-center justify-between p-4 bg-white rounded-lg border-2 border-brown/10 hover:border-teal hover:bg-teal/5 transition-all text-left group"
          >
            {'isCurrentLocation' in property && property.isCurrentLocation && (
              <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-3 py-0.5 text-xs font-medium bg-teal text-cream rounded-full whitespace-nowrap">
                You are here
              </span>
            )}
            <div>
              <h3 className="font-semibold text-brown group-hover:text-teal transition-colors">
                {property.name}
              </h3>
              <p className="text-sm text-brown/60 flex items-center gap-1 mt-0.5">
                <MapPin className="w-3 h-3" />
                {property.location}
              </p>
            </div>
            <div className="w-8 h-8 rounded-full bg-brown/5 group-hover:bg-teal group-hover:text-cream flex items-center justify-center transition-all">
              <span className="text-lg">→</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PropertySelectionStep;
